<template>
  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 7.97058V21.9706" :stroke="color" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M3 18.9706C2.73478 18.9706 2.48043 18.8652 2.29289 18.6777C2.10536 18.4902 2 18.2358 2 17.9706V4.97058C2 4.70536 2.10536 4.45101 2.29289 4.26347C2.48043 4.07594 2.73478 3.97058 3 3.97058H8C9.06087 3.97058 10.0783 4.39201 10.8284 5.14215C11.5786 5.8923 12 6.90972 12 7.97058C12 6.90972 12.4214 5.8923 13.1716 5.14215C13.9217 4.39201 14.9391 3.97058 16 3.97058H21C21.2652 3.97058 21.5196 4.07594 21.7071 4.26347C21.8946 4.45101 22 4.70536 22 4.97058V17.9706C22 18.2358 21.8946 18.4902 21.7071 18.6777C21.5196 18.8652 21.2652 18.9706 21 18.9706H15C14.2044 18.9706 13.4413 19.2867 12.8787 19.8493C12.3161 20.4119 12 21.1749 12 21.9706C12 21.1749 11.6839 20.4119 11.1213 19.8493C10.5587 19.2867 9.79565 18.9706 9 18.9706H3Z" :stroke="color" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: '#78829D',
      required: false,
    },
  },
};
</script>
